import HOTEL_SEARCH_PARAMS from './../config/hotel-search-params';
import paymentTypes from '../../../constants/payments.constant';

export default function HotelsFactory(
    $rootScope,
    userService,
    l10nService,
    hotelsOptions,
    hotelsAPI,
    authService,
) {
    'ngInject';

            let formData = null;
            let total = null;

            // TODO Get rid of state (searchResults) in hotelsFactory AP-1513
            let searchResults = null;
            const watcher = {};

            const DEFAULT_RADIUS = undefined;
            const INTIAL_SEARCH_RADIUS = 0;
            const DEFAULT_SEARCH_PARAMS = {
                HotelSorting: 0,
                min: HOTEL_SEARCH_PARAMS.DEFAULT_SEARCH_PARAMS.MIN,
                max: HOTEL_SEARCH_PARAMS.DEFAULT_SEARCH_PARAMS.MAX,
                MaximumRadius: HOTEL_SEARCH_PARAMS.DEFAULT_RADIUS,
            };

            watcher.dateComparison = function() {
                if (!(this.params.checkOutDate && this.params.checkInDate)) {
                    return;
                }
                const regionalSettings = userService.getRegionalSettings();
                const checkInDate = moment(this.params.checkInDate, regionalSettings.dateFormat);
                const checkOutDate = moment(this.params.checkOutDate, regionalSettings.dateFormat);

                if (checkInDate.isAfter(checkOutDate.add({days: -1}))) {
                    this.params.checkOutDate = null;
                }
            };

            const availableServicesFromSessionStorage = authService.getAvailableServicesFromSessionStorage();
            const _MaxTravellerAmount = availableServicesFromSessionStorage ? availableServicesFromSessionStorage.MaxTravelerAmount : 0;
            const roomsOptions = hotelsOptions && hotelsOptions.makeOptions(1, _MaxTravellerAmount ? Math.min(_MaxTravellerAmount, 8) : 8, {
                1: l10nService.localize('{} room'),
                other: l10nService.localize('{} rooms'),
            });
            const occupantsOptions = hotelsOptions && hotelsOptions.makeOptions(1, 4, {
                1: l10nService.localize('{} occupant'),
                other: l10nService.localize('{} occupants'),
            });

            const api = {
                address: '',
                addressText: '',
                watcher,
                options: {
                    roomsList: roomsOptions,
                    roomsListSelected: roomsOptions && angular.copy(roomsOptions[0]),
                    occupantsOptions,
                    occupantsSelected: occupantsOptions && angular.copy(occupantsOptions[0]),
                },
                rates: hotelsOptions && hotelsOptions.getRatesLabels(),
                params: {
                    roomsQuantity: 1,
                    occupantsQuantity: 1,
                    MaximumRadius: DEFAULT_RADIUS,
                },
                placeTypesWithId: ['establishment', 'premise'],
                maxTravellerAmount: _MaxTravellerAmount,
                getHotels,
                getTotalCount,

                refreshOptions: function(options) {
                    this.options = options;
                },

                loadMoreHotels,
                getMoreRoomsAvailable,

                getSortHotels: function(sortExpression) {
                    mergeSearchParamsWithDefault(formData);
                    formData.HotelSorting = sortExpression;
                    formData.SearchId = searchResults.searchId;
                    formData.min = 0;
                    formData.max = 20;

                    return hotelsAPI.filterHotels(formData)
                        .then(({Hotels, SearchId, Markers, FilteredTotal}) => {
                            addSearchId(Hotels, SearchId);
                            total = FilteredTotal;
                            return {Hotels, Markers};
                        });
                },

                applyFilters: function(filters) {
                    formData = formData || {};

                    Object.assign(formData, filters);

                    formData.min = 0;
                    formData.max = 20;
                    formData.SearchId = searchResults && searchResults.searchId || null;
                    formData = processMaximumRadius(formData);

                    return hotelsAPI.filterHotels(formData)
                        .then(({Hotels, SearchId, FilteredTotal, Markers, MinimumPricePerDay, MaximumPricePerDay}) => {
                            addSearchId(Hotels, SearchId);
                            total = FilteredTotal;
                            searchResults.total = FilteredTotal;
                            searchResults.minPricePerDay = MinimumPricePerDay;
                            searchResults.maxPricePerDay = MaximumPricePerDay;
                            return {Hotels, Markers};
                        });

                    function processMaximumRadius(data) {
                        if (data && data.MaximumRadiusSelected) {
                            data.MaximumRadius = data.MaximumRadiusSelected.Key;
                        }
                        return data;
                    }
                },

                setFormData: function(data) {
                    formData = formData || {};
                    Object.assign(formData, data);
                },

                getFormData: function() {
                    return formData;
                },

                getSearchResults: function() {
                    return searchResults;
                },

                isBillbackHotel,
            };

            function isBillbackHotel(hotel) {
                return hotel.PaymentTypeId === paymentTypes.BillbackPayOnDeparture;
            }

            function loadMoreHotels() {
                const totalResults = searchResults.total;
                const currentMax = formData.max;
                const step = 20;

                if ((totalResults - currentMax) >= step) {
                    formData.min = formData.max;
                    formData.max = +formData.max + step;
                } else {
                    formData.min = formData.max;
                    formData.max = totalResults;
                }

                formData.searchId = searchResults.searchId;
                formData = mergeSearchParamsWithDefault(formData);

                return hotelsAPI.filterHotels(formData)
                    .then(({Hotels, SearchId, FilteredTotal, MinimumPricePerDay, MaximumPricePerDay}) => {
                        addSearchId(Hotels, SearchId);
                        total = FilteredTotal;
                        searchResults.minPricePerDay = MinimumPricePerDay;
                        searchResults.maxPricePerDay = MaximumPricePerDay;
                        return Hotels;
                    });
            }

            function getHotels(params) {
                formData = angular.copy(params);
                formData = mergeSearchParamsWithDefault(formData);

                if (isExtendedSearch(params)) {
                    return hotelsAPI.searchFilteredHotels(formData)
                        .then(successSearchCallback);
                }

                return hotelsAPI.searchHotels(formData)
                    .then(successSearchCallback);

            }
            function isExtendedSearch(params) {
                return params
                    && params.Radius
                    && +params.Radius !== INTIAL_SEARCH_RADIUS;
            }

            function successSearchCallback(data) {
                addSearchId(data.Hotels, data.SearchId);
                total = data.Total;
                searchResults = {
                    total: data.Total,
                    searchId: data.SearchId,
                    filters: data.Filters,
                    minPricePerDay: data.MinimumPricePerDay,
                    maxPricePerDay: data.MaximumPricePerDay,
                };
                return data;
            }

            function getTotalCount() {
                return total;
            }

            function mergeSearchParamsWithDefault(params) {
                return _.merge(angular.copy(DEFAULT_SEARCH_PARAMS), params);
            }

            function addSearchId(elements, searchId) {
                angular.forEach(elements, function(element) {
                    element.searchId = searchId;
                });
            }

            function getMoreRoomsAvailable(hotelId, searchId, occupantsQuantity) {
                const params = {
                    searchhotelid: hotelId,
                    searchid: searchId,
                    OccupantsQuantity: occupantsQuantity,
                };

                Object.assign(params, formData);

                return hotelsAPI.getAvailableRooms(params);
            }

            return api;
}



// WEBPACK FOOTER //
// ./src/app/modules/hotels/services/hotelsFactory.js